import Pager from '@/components/PagerComponent'
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'

import { AffiliateStatus } from '@/enums/affiliate-status.enum'

import { useToast } from 'vue-toast-notification';

export default {

  components: {
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      criterias: {
        selectedDistributorRef: '',
        selectedCommercialProduct: '',
        selectedAffiliateStatus: '',
        selectedContractId: '',
        selectedProviderId: '',
        selectedMerchantId: '',
        selectedCreationDateStart: null,
        selectedCreationDateEnd: null,
        selectedClosingDateStart: null,
        selectedClosingDateEnd: null
      },
      displayedAffiliates: [],
      distributors: [],
      comProducts: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      affiliateStatus: AffiliateStatus,
      isDistributorLocked: false
    }
  },

  created () {
    if(this.$store.state.affiliates.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.affiliates.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('products/resetInvalidData')
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.getDistributors(user)
    this.getProducts(user)
    this.getCriterias(user)
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    search () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.$store.dispatch('affiliates/setCriterias', this.criterias)
        this.getBeneficiarys()
      }
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
      if (user.ihmDistribRef) {
        this.criterias.selectedDistributorRef = user.ihmDistribRef
        this.isDistributorLocked = true
      }
    },

    async getProducts (user) {
      for (const tmpPprdcRefList of Object.values(user.comProductsMap)) {
        this.comProducts = this.comProducts.concat(Object.values(tmpPprdcRefList)[0])
      }
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    async getCriterias (user) {
      if(this.$store.state.affiliates.criterias && this.$store.state.affiliates.affiliates.length > 0) {
        this.criterias = this.$store.state.affiliates.criterias
      }
      if (user.ihmDistribRef) { // Au cas où le distributeur serait changé
        this.criterias.selectedDistributorRef = user.ihmDistribRef
      }
    },

    updateComProducts () {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.comProducts = Object.values(user.comProductsMap[this.criterias.selectedDistributorRef])[0]
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    async getBeneficiarys () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('affiliates/reset')
      await this.$store.dispatch('affiliates/search', {
        issuerId: this.getIssuerId(this.criterias.selectedDistributorRef),
        distributorRef: this.criterias.selectedDistributorRef,
        commercialProduct: this.criterias.selectedCommercialProduct,
        affiliateStatus: this.criterias.selectedAffiliateStatus,
        contractId: this.criterias.selectedContractId,
        providerId: this.criterias.selectedProviderId,
        merchantId: this.criterias.selectedMerchantId,
        creationDateStart: this.criterias.selectedCreationDateStart,
        creationDateEnd: this.criterias.selectedCreationDateEnd,
        closingDateStart: this.criterias.selectedClosingDateStart,
        closingDateEnd: this.criterias.selectedClosingDateEnd
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = (error || 'BAD_REQUEST').toUpperCase()
        }
      )
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    async showDetails (affiliate) {
      this.$store.dispatch('affiliates/setAffiliate', affiliate)
      this.$router.push({ name: 'affiliate-detail' })
    },

    async editAffiliate (affiliate) {
      this.$store.dispatch('affiliates/setAffiliate', affiliate)
      this.$router.push({ name: 'affiliate-edit' })
    },

    reset () {
      this.$store.dispatch('affiliates/reset')
      this.$store.dispatch('affiliates/resetCriterias')
      this.validationError = false
      this.error = false
      if (!this.isDistributorLocked) {
        this.criterias.selectedDistributorRef = ''
      }
      this.criterias.selectedCommercialProduct = ''
      this.criterias.selectedAffiliateStatus = ''
      this.criterias.selectedContractId = ''
      this.criterias.selectedProviderId = ''
      this.criterias.selectedMerchantId = ''
      this.criterias.selectedCreationDateStart = null
      this.criterias.selectedCreationDateEnd = null
      this.criterias.selectedClosingDateStart = null
      this.criterias.selectedClosingDateEnd = null
    }
  },

  validations() {
    return {
      criterias: {
        selectedDistributorRef: { required },
        selectedCommercialProduct: {},
        selectedAffiliateStatus: {},
        selectedContractId: {},
        selectedProviderId: {},
        selectedMerchantId: {},
        selectedCreationDateStart: {
          required: requiredIf(function() { return this.criterias.selectedCreationDateEnd })
        },
        selectedCreationDateEnd: {
          required: requiredIf(function() { return this.criterias.selectedCreationDateStart })
        },
        selectedClosingDateStart: {
          required: requiredIf(function() { return this.criterias.selectedClosingDateEnd })
        },
        selectedClosingDateEnd: {
          required: requiredIf(function() { return this.criterias.selectedClosingDateStart })
        }
      }
    }
  }
}
